import { baseUrl, jwtHeaders } from '../common/data';

export const updateMsg91Whatsapp = async (ownerId, data) => {
  const response = await fetch(`${baseUrl}/api/owner/msg91whatsapp/${ownerId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: jwtHeaders(),
  });
  const resData = await response?.json();

  return resData;
};

export const resetWhatsappSettings = async (ownerId) => {
  const response = await fetch(`${baseUrl}/api/owner/resetwhatsappsettings/${ownerId}`, {
    method: 'PUT',
    headers: jwtHeaders(),
  });
  const resData = await response?.json();

  return resData;
};

export const updateMsg91Whatsapptemplatenames = async (ownerId, data) => {
  const response = await fetch(`${baseUrl}/api/owner/msg91whatsapptemplatenames/${ownerId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: jwtHeaders(),
  });
  const resData = await response?.json();

  return resData;
};

export const getWhatsappSettings = async (ownerId) => {
  const response = await fetch(`${baseUrl}/api/owner/whatsappsettings/${ownerId}`, {
    method: 'GET',
    headers: jwtHeaders(),
  });
  const resData = await response?.json();

  return resData;
};
